<template>
    <v-container>
        <v-row >
            <!-- LOCATION TYPES -->
            <v-col cols="12">
                <v-card>
                    <v-row >
                        <v-col cols="12">
                            <h2 class="text-center">Location Types</h2>
                        </v-col>
                    </v-row>

                    <v-row >
                        <v-col cols="12" sm="3" offset-sm="1">
                            <v-checkbox
                                label="Active Only"
                                v-model="locationTypesActiveOnly"
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" offset-sm="1">
                        </v-col>
                        <v-col cols="12" sm="2" offset-sm="1">
                            <v-btn
                                v-if="!auth.currentUserIsReadOnly()"
                                color="success"
                                block
                                @click="editLocationType({ Active: true })"
                            >
                                Add
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row >
                        <v-col>
                            <v-data-table
                                :headers="headers('locationTypes')"
                                :items="locationTypesFiltered"
                                :loading="locationTypesLoading"
                                :sort-by.sync="locationTypesPagination.sortBy"
                                :sort-desc.sync="locationTypesPagination.sortDesc"
                                :items-per-page.sync="locationTypesPagination.rowsPerPage"
                                :page.sync="locationTypesPagination.page"
                                :footer-props="footerProps"
                                must-sort
                            >
                                <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                                <template slot="item" slot-scope="props">
                                    <tr :data-id="props.item.LocationTypeID">
                                        <td>{{props.item.Text}}</td>
                                        <td v-if="props.item.Active"><v-icon color="success">check</v-icon></td>
                                        <td v-if="!props.item.Active"><v-icon color="error">close</v-icon></td>
                                        <td v-if="!auth.currentUserIsReadOnly()">
                                            <v-btn
                                                color="warning"
                                                block
                                                @click="editLocationType(props.item)"
                                            >
                                                Edit
                                            </v-btn>
                                        </td>
                                        <td v-else></td>
                                    </tr>
                                </template>
                                <template v-if="!locationTypesLoading" slot="no-data">
                                    <v-alert v-if="locationTypesLoadError" outlined :value="true" color="error" icon="error">
                                        {{locationTypesLoadError}}
                                    </v-alert>
                                    <v-alert v-if="!locationTypesLoadError" outlined :value="true" type="info">
                                        No results found
                                    </v-alert>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <!-- END LOCATION TYPES -->

            <!-- ROOMS -->
            <v-col cols="12">
                <v-card>
                    <v-row >
                        <v-col cols="12">
                            <h2 class="text-center">Rooms</h2>
                        </v-col>
                    </v-row>

                    <v-row >
                        <v-col cols="12" sm="3" offset-sm="1">
                            <v-checkbox
                                label="Active Only"
                                v-model="roomsActiveOnly"
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" offset-sm="1">
                        </v-col>
                        <v-col cols="12" sm="2" offset-sm="1">
                            <v-btn
                                v-if="!auth.currentUserIsReadOnly()"
                                color="success"
                                block
                                @click="editRoom({ Active: true })"
                            >
                                Add
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row >
                        <v-col>
                            <v-data-table
                                :headers="headers('rooms')"
                                :items="roomsFiltered"
                                :loading="roomsLoading"
                                :sort-by.sync="roomsPagination.sortBy"
                                :sort-desc.sync="roomsPagination.sortDesc"
                                :items-per-page.sync="roomsPagination.rowsPerPage"
                                :page.sync="roomsPagination.page"
                                :footer-props="footerProps"
                                must-sort
                            >
                                <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                                <template slot="item" slot-scope="props">
                                    <tr :data-id="props.item.RoomID">
                                        <td>{{props.item.Text}}</td>
                                        <td v-if="props.item.Active"><v-icon color="success">check</v-icon></td>
                                        <td v-if="!props.item.Active"><v-icon color="error">close</v-icon></td>
                                        <td v-if="!auth.currentUserIsReadOnly()">
                                            <v-btn
                                                color="warning"
                                                block
                                                @click="editRoom(props.item)"
                                            >
                                                Edit
                                            </v-btn>
                                        </td>
                                        <td v-else></td>
                                    </tr>
                                </template>
                                <template v-if="!roomsLoading" slot="no-data">
                                    <v-alert v-if="roomsLoadError" outlined :value="true" color="error" icon="error">
                                        {{roomsLoadError}}
                                    </v-alert>
                                    <v-alert v-if="!roomsLoadError" outlined :value="true" type="info">
                                        No results found
                                    </v-alert>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <!-- END ROOMS -->

            <!-- SUITE NUMBERS -->
            <v-col cols="12">
                <v-card>
                    <v-row >
                        <v-col cols="12">
                            <h2 class="text-center">Suite Numbers</h2>
                        </v-col>
                    </v-row>

                    <v-row >
                        <v-col cols="12" sm="3" offset-sm="1">
                            <v-checkbox
                                label="Active Only"
                                v-model="suiteNumbersActiveOnly"
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" offset-sm="1">
                        </v-col>
                        <v-col cols="12" sm="2" offset-sm="1">
                            <v-btn
                                v-if="!auth.currentUserIsReadOnly()"
                                color="success"
                                block
                                @click="editSuiteNumber({ Active: true })"
                            >
                                Add
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row >
                        <v-col>
                            <v-data-table
                                :headers="headers('suiteNumbers')"
                                :items="suiteNumbersFiltered"
                                :loading="suiteNumbersLoading"
                                :sort-by.sync="suiteNumbersPagination.sortBy"
                                :sort-desc.sync="suiteNumbersPagination.sortDesc"
                                :items-per-page.sync="suiteNumbersPagination.rowsPerPage"
                                :page.sync="suiteNumbersPagination.page"
                                :footer-props="footerProps"
                                must-sort
                            >
                                <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                                <template slot="item" slot-scope="props">
                                    <tr :data-id="props.item.SuiteNumberID">
                                        <td>{{props.item.Text}}</td>
                                        <td v-if="props.item.Active"><v-icon color="success">check</v-icon></td>
                                        <td v-if="!props.item.Active"><v-icon color="error">close</v-icon></td>
                                        <td v-if="!auth.currentUserIsReadOnly()">
                                            <v-btn
                                                color="warning"
                                                block
                                                @click="editSuiteNumber(props.item)"
                                            >
                                                Edit
                                            </v-btn>
                                        </td>
                                        <td v-else></td>
                                    </tr>
                                </template>
                                <template v-if="!suiteNumbersLoading" slot="no-data">
                                    <v-alert v-if="suiteNumbersLoadError" outlined :value="true" color="error" icon="error">
                                        {{suiteNumbersLoadError}}
                                    </v-alert>
                                    <v-alert v-if="!suiteNumbersLoadError" outlined :value="true" type="info">
                                        No results found
                                    </v-alert>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <!-- END SUITE NUMBERS -->
            

            <!-- Drawers -->
            <v-col cols="12">
                <v-card>
                    <v-row >
                        <v-col cols="12">
                            <h2 class="text-center">Drawers</h2>
                        </v-col>
                    </v-row>

                    <v-row >
                        <v-col cols="12" sm="3" offset-sm="1">
                            <v-checkbox
                                label="Active Only"
                                v-model="drawersActiveOnly"
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" offset-sm="1">
                        </v-col>
                        <v-col cols="12" sm="2" offset-sm="1">
                            <v-btn
                                v-if="!auth.currentUserIsReadOnly()"
                                color="success"
                                block
                                @click="editDrawer({ Active: true })"
                            >
                                Add
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row >
                        <v-col>
                            <v-data-table
                                :headers="headers('drawers')"
                                :items="drawersFiltered"
                                :loading="drawersLoading"
                                :sort-by.sync="drawersPagination.sortBy"
                                :sort-desc.sync="drawersPagination.sortDesc"
                                :items-per-page.sync="drawersPagination.rowsPerPage"
                                :page.sync="drawersPagination.page"
                                :footer-props="footerProps"
                                must-sort
                            >
                                <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                                <template slot="item" slot-scope="props">
                                    <tr :data-id="props.item.DrawerID">
                                        <td>{{props.item.Text}}</td>
                                        <td v-if="props.item.Active"><v-icon color="success">check</v-icon></td>
                                        <td v-if="!props.item.Active"><v-icon color="error">close</v-icon></td>
                                        <td v-if="!auth.currentUserIsReadOnly()">
                                            <v-btn
                                                color="warning"
                                                block
                                                @click="editDrawer(props.item)"
                                            >
                                                Edit
                                            </v-btn>
                                        </td>
                                        <td v-else></td>
                                    </tr>
                                </template>
                                <template v-if="!drawersLoading" slot="no-data">
                                    <v-alert v-if="drawersLoadError" outlined :value="true" color="error" icon="error">
                                        {{drawersLoadError}}
                                    </v-alert>
                                    <v-alert v-if="!drawersLoadError" outlined :value="true" type="info">
                                        No results found
                                    </v-alert>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <!-- END Drawers -->
        </v-row>
        
        <!-- LOCATION TYPE DIALOG -->
        <v-dialog v-model="locationTypeShowEditDialog" transition="dialog-bottom-transition" max-width="500px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark :disabled="locationTypesSaving" @click="cancelEditLocationType">
                        <v-icon large>close</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-toolbar-title v-if="locationTypeEdited && locationTypeEdited.LocationID">Edit Location Type</v-toolbar-title>
                    <v-toolbar-title v-else>Add New Location Type</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        
                    </v-toolbar-items>
                </v-toolbar>
                <v-form @submit.prevent ref="editForm" v-model="locationTypeEditValid">
                    <v-row class="dialog-content">
                        <v-col cols="12">
                            <v-row >
                                <v-col cols="12">
                                    <v-text-field
                                        clearable
                                        counter="200"
                                        maxlength="200"
                                        v-model="locationTypeEdited.Text"
                                        :rules="[rules.required]"
                                        label="Location Type">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-checkbox label="Active" v-model="locationTypeEdited.Active"></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row  class="dialog-action-buttons">
                                <v-col cols="12" sm="6">
                                    <v-btn block color="error" :disabled="locationTypesSaving" @click="cancelEditLocationType">Cancel</v-btn>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-btn block color="success" :disabled="!locationTypeEditValid" :loading="locationTypesSaving" @click="saveEditedLocationType">Save</v-btn>
                                </v-col>
                                <v-col cols="12" v-if="locationTypesSaveError">
                                    <v-alert text type="error">{{ locationTypesSaveError }}</v-alert>
                                </v-col>
                            </v-row>                            
                        </v-col>
                    </v-row>
                </v-form>
            </v-card>
        </v-dialog>
        <!-- END LOCATION TYPE DIALOG -->

        <!-- SUITE NUMBER DIALOG -->
        <v-dialog v-model="suiteNumberShowEditDialog" transition="dialog-bottom-transition" max-width="500px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark :disabled="suiteNumbersSaving" @click="cancelEditSuiteNumber">
                        <v-icon large>close</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-toolbar-title v-if="suiteNumberEdited && suiteNumberEdited.LocationID">Edit Suite Number</v-toolbar-title>
                    <v-toolbar-title v-else>Add New Suite Number</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        
                    </v-toolbar-items>
                </v-toolbar>
                <v-form @submit.prevent ref="editForm" v-model="suiteNumberEditValid">
                    <v-row class="dialog-content">
                        <v-col cols="12">
                            <v-row >
                                <v-col cols="12">
                                    <v-text-field
                                        clearable
                                        counter="200"
                                        maxlength="200"
                                        v-model="suiteNumberEdited.Text"
                                        :rules="[rules.required]"
                                        label="Suite Number">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-checkbox label="Active" v-model="suiteNumberEdited.Active"></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row  class="dialog-action-buttons">
                                <v-col cols="12" sm="6">
                                    <v-btn block color="error" :disabled="suiteNumbersSaving" @click="cancelEditSuiteNumber">Cancel</v-btn>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-btn block color="success" :disabled="!suiteNumberEditValid" :loading="suiteNumbersSaving" @click="saveEditedSuiteNumber">Save</v-btn>
                                </v-col>
                                <v-col cols="12" v-if="suiteNumbersSaveError">
                                    <v-alert text type="error">{{ suiteNumbersSaveError }}</v-alert>
                                </v-col>
                            </v-row>                            
                        </v-col>
                    </v-row>
                </v-form>
            </v-card>
        </v-dialog>
        <!-- END SUITE NUMBER DIALOG -->

        <!-- ROOM DIALOG -->
        <v-dialog v-model="roomShowEditDialog" transition="dialog-bottom-transition" max-width="500px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark :disabled="roomsSaving" @click="cancelEditRoom">
                        <v-icon large>close</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-toolbar-title v-if="roomEdited && roomEdited.LocationID">Edit Room</v-toolbar-title>
                    <v-toolbar-title v-else>Add New Room</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        
                    </v-toolbar-items>
                </v-toolbar>
                <v-form @submit.prevent ref="editForm" v-model="roomEditValid">
                    <v-row class="dialog-content">
                        <v-col cols="12">
                            <v-row >
                                <v-col cols="12">
                                    <v-text-field
                                        clearable
                                        counter="200"
                                        maxlength="200"
                                        v-model="roomEdited.Text"
                                        :rules="[rules.required]"
                                        label="Room">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-checkbox label="Active" v-model="roomEdited.Active"></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row  class="dialog-action-buttons">
                                <v-col cols="12" sm="6">
                                    <v-btn block color="error" :disabled="roomsSaving" @click="cancelEditRoom">Cancel</v-btn>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-btn block color="success" :disabled="!roomEditValid" :loading="roomsSaving" @click="saveEditedRoom">Save</v-btn>
                                </v-col>
                                <v-col cols="12" v-if="roomsSaveError">
                                    <v-alert text type="error">{{ roomsSaveError }}</v-alert>
                                </v-col>
                            </v-row>                            
                        </v-col>
                    </v-row>
                </v-form>
            </v-card>
        </v-dialog>
        <!-- END ROOM DIALOG -->

        <!-- DRAWER DIALOG -->
        <v-dialog v-model="drawerShowEditDialog" transition="dialog-bottom-transition" max-width="500px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark :disabled="drawersSaving" @click="cancelEditDrawer">
                        <v-icon large>close</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-toolbar-title v-if="drawerEdited && drawerEdited.LocationID">Edit Drawer</v-toolbar-title>
                    <v-toolbar-title v-else>Add New Drawer</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        
                    </v-toolbar-items>
                </v-toolbar>
                <v-form @submit.prevent ref="editForm" v-model="drawerEditValid">
                    <v-row class="dialog-content">
                        <v-col cols="12">
                            <v-row >
                                <v-col cols="12">
                                    <v-text-field
                                        clearable
                                        counter="200"
                                        maxlength="200"
                                        v-model="drawerEdited.Text"
                                        :rules="[rules.required]"
                                        label="Drawer">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-checkbox label="Active" v-model="drawerEdited.Active"></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row  class="dialog-action-buttons">
                                <v-col cols="12" sm="6">
                                    <v-btn block color="error" :disabled="drawersSaving" @click="cancelEditDrawer">Cancel</v-btn>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-btn block color="success" :disabled="!drawerEditValid" :loading="drawersSaving" @click="saveEditedDrawer">Save</v-btn>
                                </v-col>
                                <v-col cols="12" v-if="drawersSaveError">
                                    <v-alert text type="error">{{ drawersSaveError }}</v-alert>
                                </v-col>
                            </v-row>                            
                        </v-col>
                    </v-row>
                </v-form>
            </v-card>
        </v-dialog>
        <!-- END DRAWER DIALOG -->
    </v-container>
</template>

<script>
import validationRules from "../../helpers/validationrules";
import * as auth from '@/services/auth';
import { mapState } from 'vuex';

export default {
    components: {
    },
    props: [
        
    ],
    data() {
        return {
            auth: auth,
            rules: validationRules.rules,
            
            footerProps: {
                'items-per-page-options': [5, 20, 50, 100]
            },

            locationTypesActiveOnly: true,
            locationTypeEdited: {},
            locationTypeShowEditDialog: false,
            locationTypeEditValid: false,
            locationTypesPagination: {
                rowsPerPage: 20, // default
                sortBy: "Text",
                descending: false
            },
            
            suiteNumbersActiveOnly: true,
            suiteNumberEdited: {},
            suiteNumberShowEditDialog: false,
            suiteNumberEditValid: false,
            suiteNumbersPagination: {
                rowsPerPage: 20, // default
                sortBy: "Text",
                descending: false
            },

            roomsActiveOnly: true,
            roomEdited: {},
            roomShowEditDialog: false,
            roomEditValid: false,
            roomsPagination: {
                rowsPerPage: 20, // default
                sortBy: "Text",
                descending: false
            },

            drawersActiveOnly: true,
            drawerEdited: {},
            drawerShowEditDialog: false,
            drawerEditValid: false,
            drawersPagination: {
                rowsPerPage: 20, // default
                sortBy: "Text",
                descending: false
            },
        };
    },
    computed: {
        ...mapState("locationStore", {
            locationTypes: state => state.locationTypes,
            suiteNumbers: state => state.suiteNumbers,
            rooms: state => state.rooms,
            drawers: state => state.drawers,
            
            locationTypesLoading: state => state.locationTypesLoading,
            suiteNumbersLoading: state => state.suiteNumbersLoading,
            roomsLoading: state => state.roomsLoading,
            drawersLoading: state => state.drawersLoading,
            
            locationTypesLoadError: state => state.locationTypesLoadError,
            suiteNumbersLoadError: state => state.suiteNumbersLoadError,
            roomsLoadError: state => state.roomsLoadError,
            drawersLoadError: state => state.drawersLoadError,

            locationTypesSaving: state => state.locationTypesSaving,
            suiteNumbersSaving: state => state.suiteNumbersSaving,
            roomsSaving: state => state.roomsSaving,
            drawersSaving: state => state.drawersSaving,

            locationTypesSaveError: state => state.locationTypesSaveError,
            suiteNumbersSaveError: state => state.suiteNumbersSaveError,
            roomsSaveError: state => state.roomsSaveError,
            drawersSaveError: state => state.drawersSaveError,
        }),
        locationTypesFiltered() {
            return this.locationTypes.filter(s => s.Active || !this.locationTypesActiveOnly);
        },
        suiteNumbersFiltered() {
            return this.suiteNumbers.filter(s => s.Active || !this.suiteNumbersActiveOnly);
        },
        roomsFiltered() {
            return this.rooms.filter(s => s.Active || !this.roomsActiveOnly);
        },
        drawersFiltered() {
            return this.drawers.filter(s => s.Active || !this.drawersActiveOnly);
        }
    },
    methods: {
        headers(dataType) {
            let textHeader = "";

            if (dataType == "locationTypes") {
                textHeader = "Location Type";
            }
            if (dataType == "suiteNumbers") {
                textHeader = "Suite Number";
            }
            if (dataType == "rooms") {
                textHeader = "Room";
            }
            if (dataType == "drawers") {
                textHeader = "Drawers";
            }

            return [
                {
                    text: textHeader,
                    value: "Text"
                },
                {
                    text: "Active",
                    value: "Active"
                },
                {
                    text: "", // edit button
                    sortable: false,
                    width: "100px"
                }
            ]
        },
        loadLocationTypes() {
            this.$store.dispatch("locationStore/loadLocationTypes");
        },
        loadSuiteNumbers() {
            this.$store.dispatch("locationStore/loadSuiteNumbers");
        },
        loadRooms() {
            this.$store.dispatch("locationStore/loadRooms");
        },
        loadDrawers() {
            this.$store.dispatch("locationStore/loadDrawers");
        },

        editLocationType(item) {
            this.$store.dispatch("locationStore/clearSaveErrors");
            this.locationTypeEdited = Object.assign({}, item);
            this.locationTypeShowEditDialog = true;
            this.$nextTick(() => this.$refs.editForm.validate()); // show which fields are mandatory when opening the edit form
        },
        cancelEditLocationType() {
            this.locationTypeShowEditDialog = false;
            this.locationTypeEdited = {};
        },
        saveEditedLocationType() {
            var that = this;

            this.$store.dispatch("locationStore/saveLocationType", {
                locationType: this.locationTypeEdited,
                finally: function() {
                    if (!that.locationTypesSaveError) {
                        // only close dialog if there was no error (error will be displayed automatically if it exists)
                        that.cancelEditLocationType();
                    }
                }
            });
        },

        editSuiteNumber(item) {
            this.$store.dispatch("locationStore/clearSaveErrors");
            this.suiteNumberEdited = Object.assign({}, item);
            this.suiteNumberShowEditDialog = true;
            this.$nextTick(() => this.$refs.editForm.validate()); // show which fields are mandatory when opening the edit form
        },
        cancelEditSuiteNumber() {
            this.suiteNumberShowEditDialog = false;
            this.suiteNumberEdited = {};
        },
        saveEditedSuiteNumber() {
            var that = this;

            this.$store.dispatch("locationStore/saveSuiteNumber", {
                suiteNumber: this.suiteNumberEdited,
                finally: function() {
                    if (!that.suiteNumbersSaveError) {
                        // only close dialog if there was no error (error will be displayed automatically if it exists)
                        that.cancelEditSuiteNumber();
                    }
                }
            });
        },

        editRoom(item) {
            this.$store.dispatch("locationStore/clearSaveErrors");
            this.roomEdited = Object.assign({}, item);
            this.roomShowEditDialog = true;
            this.$nextTick(() => this.$refs.editForm.validate()); // show which fields are mandatory when opening the edit form
        },
        cancelEditRoom() {
            this.roomShowEditDialog = false;
            this.roomEdited = {};
        },
        saveEditedRoom() {
            var that = this;

            this.$store.dispatch("locationStore/saveRoom", {
                room: this.roomEdited,
                finally: function() {
                    if (!that.roomsSaveError) {
                        // only close dialog if there was no error (error will be displayed automatically if it exists)
                        that.cancelEditRoom();
                    }
                }
            });
        },

        editDrawer(item) {
            this.$store.dispatch("locationStore/clearSaveErrors");
            this.drawerEdited = Object.assign({}, item);
            this.drawerShowEditDialog = true;
            this.$nextTick(() => this.$refs.editForm.validate()); // show which fields are mandatory when opening the edit form
        },
        cancelEditDrawer() {
            this.drawerShowEditDialog = false;
            this.drawerEdited = {};
        },
        saveEditedDrawer() {
            var that = this;

            this.$store.dispatch("locationStore/saveDrawer", {
                drawer: this.drawerEdited,
                finally: function() {
                    if (!that.drawersSaveError) {
                        // only close dialog if there was no error (error will be displayed automatically if it exists)
                        that.cancelEditDrawer();
                    }
                }
            });
        }
    },
    created() {
        this.loadLocationTypes();
        this.loadSuiteNumbers();
        this.loadRooms();
        this.loadDrawers();
    }
};
</script>

<style>
    
</style>